import { initializeApp, getApp } from "firebase/app"
import { getFirestore, Timestamp } from "firebase/firestore"
import { getAuth, onAuthStateChanged } from "firebase/auth"
// import { getStorage } from "firebase/storage"
import { getRemoteConfig, } from "firebase/remote-config"
import { getFunctions } from "firebase/functions"
import { getAnalytics, logEvent, } from 'firebase/analytics';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCXQ7u8AMN4nZBJVrmClX-65uNoWalHmqg",
    authDomain: "thanking-teachers.firebaseapp.com",
    projectId: "thanking-teachers",
    storageBucket: "thanking-teachers.firebasestorage.app",
    messagingSenderId: "455680209576",
    appId: "1:455680209576:web:a357e9c3f7782f4d4c489d",
    measurementId: "G-H65YCNN26K"
};

// init firebase
initializeApp(firebaseConfig);
console.log('App is initialized.')

// Now we initialize the Authentication.
const auth = getAuth()
const isSignedIn = auth.currentUser !== null

// init services
const db = getFirestore()

// Storage services
// const storage = getStorage()

// Remote config
const config = getRemoteConfig()

// Firebase analytics
const analytics = getAnalytics()

// Functions
let funcs
if (process.env.NODE_ENV.trim() === 'development') {
    console.log('In dev mode. connectiong app to functions.')
    funcs = getFunctions(getApp())
}
else {
    funcs = getFunctions()
}

export { db, auth, isSignedIn, onAuthStateChanged, Timestamp, config, funcs, analytics, logEvent }
